import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuxiliarService } from './../../auxiliar.service';
import { AuthService } from './../auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class MaterialesService {

  server: string = '';
  token: string = '';

  constructor(private auth: AuthService, private httpClient: HttpClient, private auxiliarService: AuxiliarService) {
    this.server = this.auxiliarService.getServidor()+"/api/materiales";
    this.token = this.auth.getToken();
  }

  getMateriales(tipo: string = 'all', hidden: string = 'true') {
    const formData = new FormData();
    formData.append('tipo', tipo);
    formData.append('hidden', hidden);
    return this.httpClient.post(this.server+'/get', formData);
  }

  newMaterial(nombre: string, descripcion: string, tipo: string, activo: string) {
    const formData = new FormData();
    formData.append('nombre', nombre);
    formData.append('descripcion', descripcion);
    formData.append('tipo', tipo);
    formData.append('activo', activo);
    return this.httpClient.post(this.server, formData);
  }

  editMaterial(id: number, nombre: string, descripcion: string, tipo: string, activo: string) {
    const formData = new FormData();
    formData.append('idMaterial', id.toString());
    formData.append('nombre', nombre);
    formData.append('descripcion', descripcion);
    formData.append('tipo', tipo);
    formData.append('activo', activo);
    return this.httpClient.post(this.server+"/update", formData);
  }

  deleteMaterial(id: number){
    return this.httpClient.delete(this.server+"/"+id);
  }

}
